<template>
  <div class="banner-section" :style="{ background: background }" @click="$emit('click')">
    <div class="banner-section__left">
      <img
        class="banner-section__icon"
        :src="icon"
        :alt="title"
      />
      <div class="banner-section__text">
        <span class="typo-md-semi">{{ title }}</span>
        <span class="typo-sm-medium">{{ description }}</span>
      </div>
    </div>
    <img
      class="banner-section__arrow"
      src="@/assets/home/icn_arrow_right_gray.png"
      alt="arrow"
    />
  </div>
</template>

<script>
export default {
  name: 'BannerSection',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    background: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.banner-section {
  display: flex;
  padding: 20px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  margin: 0 16px;
  box-sizing: border-box;
  cursor: pointer;
}

.banner-section__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.banner-section__icon {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.banner-section__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.banner-section__arrow {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/BannerSection.vue